var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var UploadCollection = /** @class */ (function (_super) {
    __extends(UploadCollection, _super);
    function UploadCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new upload collection
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/upload-collection/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    UploadCollection.prototype.create = function (body) {
        return this.rawCreate(Utils.serializeRequestBody(body, {
            type: 'upload_collection',
            attributes: ['label', 'position'],
            relationships: ['parent'],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Create a new upload collection
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/upload-collection/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    UploadCollection.prototype.rawCreate = function (body) {
        return this.client.request({
            method: 'POST',
            url: '/upload-collections',
            body: body,
        });
    };
    /**
     * Update a upload collection
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/upload-collection/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    UploadCollection.prototype.update = function (uploadCollectionId, body) {
        return this.rawUpdate(Utils.toId(uploadCollectionId), Utils.serializeRequestBody(body, {
            id: Utils.toId(uploadCollectionId),
            type: 'upload_collection',
            attributes: ['label', 'position'],
            relationships: ['parent', 'children'],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Update a upload collection
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/upload-collection/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    UploadCollection.prototype.rawUpdate = function (uploadCollectionId, body) {
        return this.client.request({
            method: 'PUT',
            url: "/upload-collections/".concat(uploadCollectionId),
            body: body,
        });
    };
    /**
     * List all upload collections
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/upload-collection/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    UploadCollection.prototype.list = function (queryParams) {
        return this.rawList(queryParams).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * List all upload collections
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/upload-collection/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    UploadCollection.prototype.rawList = function (queryParams) {
        return this.client.request({
            method: 'GET',
            url: '/upload-collections',
            queryParams: queryParams,
        });
    };
    /**
     * Retrieve a upload collection
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/upload-collection/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    UploadCollection.prototype.find = function (uploadCollectionId) {
        return this.rawFind(Utils.toId(uploadCollectionId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Retrieve a upload collection
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/upload-collection/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    UploadCollection.prototype.rawFind = function (uploadCollectionId) {
        return this.client.request({
            method: 'GET',
            url: "/upload-collections/".concat(uploadCollectionId),
        });
    };
    /**
     * Delete a upload collection
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/upload-collection/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    UploadCollection.prototype.destroy = function (uploadCollectionId) {
        return this.rawDestroy(Utils.toId(uploadCollectionId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Delete a upload collection
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/upload-collection/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    UploadCollection.prototype.rawDestroy = function (uploadCollectionId) {
        return this.client.request({
            method: 'DELETE',
            url: "/upload-collections/".concat(uploadCollectionId),
        });
    };
    /**
     * Reorders a set of upload collections
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/upload-collection/reorder
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     *
     * @deprecated This API call is to be considered private and might change without notice
     */
    UploadCollection.prototype.reorder = function (body) {
        return this.rawReorder(Utils.serializeRequestBody(body, {
            type: 'upload_collection',
            attributes: ['position'],
            relationships: ['parent'],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Reorders a set of upload collections
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/upload-collection/reorder
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     *
     * @deprecated This API call is to be considered private and might change without notice
     */
    UploadCollection.prototype.rawReorder = function (body) {
        return this.client.request({
            method: 'POST',
            url: '/upload-collections/reorder',
            body: body,
        });
    };
    UploadCollection.TYPE = 'upload_collection';
    return UploadCollection;
}(BaseResource));
export default UploadCollection;
//# sourceMappingURL=UploadCollection.js.map